var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiCry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 27.8C22.4722 27.8 27.8 22.4722 27.8 15.9C27.8 9.32781 22.4722 4 15.9 4C9.32781 4 4 9.32781 4 15.9C4 22.4722 9.32781 27.8 15.9 27.8Z",
    fill: "url(#paint0_linear_7560_45762)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2016 15.2001C13.2016 16.4001 12.4016 17.3001 11.4016 17.3001C10.4016 17.3001 9.60156 16.3001 9.60156 15.2001C9.60156 14.1001 10.4016 13.1001 11.4016 13.1001C12.3016 13.1001 13.2016 14.1001 13.2016 15.2001Z",
    fill: "#26304E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9031 14.5999C11.9031 14.9999 11.6031 15.2999 11.3031 15.2999C11.0031 15.2999 10.7031 14.9999 10.7031 14.5999C10.7031 14.1999 11.0031 13.8999 11.3031 13.8999C11.7031 13.8999 11.9031 14.1999 11.9031 14.5999Z",
    fill: "#3E4762"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4016 17.3001C21.3957 17.3001 22.2016 16.3599 22.2016 15.2001C22.2016 14.0403 21.3957 13.1001 20.4016 13.1001C19.4074 13.1001 18.6016 14.0403 18.6016 15.2001C18.6016 16.3599 19.4074 17.3001 20.4016 17.3001Z",
    fill: "#26304E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1023 14.5003C21.1023 14.9003 20.8023 15.2003 20.5023 15.2003C20.2023 15.2003 19.9023 14.9003 19.9023 14.5003C19.9023 14.1003 20.2023 13.8003 20.5023 13.8003C20.8023 13.8003 21.1023 14.1003 21.1023 14.5003Z",
    fill: "#3E4762"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0993 23.2C19.4993 21.8 18.2993 20 15.8993 20C13.4993 20 12.2993 21.8 11.6993 23.2C11.5993 23.6 11.9993 23.9 12.2993 23.6C13.8993 22.4 15.9993 22.4 15.9993 22.4C15.9993 22.4 17.9993 22.4 19.6993 23.6C19.7993 23.8 20.2993 23.5 20.0993 23.2Z",
    fill: "url(#paint1_linear_7560_45762)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69844 13.7C7.49844 13.7 7.39844 13.6 7.29844 13.5C7.09844 13.3 7.09844 12.9 7.29844 12.6C7.59844 12.3 9.99844 10 11.9984 10C12.2984 10 12.5984 10.3 12.5984 10.6C12.5984 10.9 12.2984 11.2 11.9984 11.2C10.6984 11.2 8.79844 12.8 8.19844 13.5C7.99844 13.7 7.79844 13.7 7.69844 13.7Z",
    fill: "#D97700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0992 13.7C24.2992 13.7 24.3992 13.6 24.4992 13.5C24.6992 13.3 24.6992 12.9 24.4992 12.6C24.1992 12.3 21.7992 10 19.7992 10C19.4992 10 19.1992 10.3 19.1992 10.6C19.1992 10.9 19.4992 11.2 19.7992 11.2C21.0992 11.2 22.9992 12.8 23.5992 13.5C23.7992 13.7 23.8992 13.7 24.0992 13.7Z",
    fill: "#D97700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 24.7002C25.8 26.0002 24.7 27.1002 23.4 27.1002C22.1 27.1002 21 26.0002 21 24.7002C21 23.4002 23.4 19.2002 23.4 19.2002C23.4 19.2002 25.8 23.3002 25.8 24.7002Z",
    fill: "url(#paint2_linear_7560_45762)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7560_45762",
    x1: 15.8879,
    y1: 3.8995,
    x2: 15.8879,
    y2: 27.6045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7560_45762",
    x1: 15.8871,
    y1: 19.9842,
    x2: 15.8871,
    y2: 23.6502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D4C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7560_45762",
    x1: 23.4096,
    y1: 19.2218,
    x2: 23.4096,
    y2: 27.1235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1081D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2266,
    stopColor: "#2EB4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6797,
    stopColor: "#26B4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67D6FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiCry);
export default __webpack_public_path__ + "static/media/emoji_cry.d80b8114.svg";
export { ForwardRef as ReactComponent };